function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import TranslationManager from './../infrastructure/translation-manager';
import { TranslationKeys } from './../infrastructure/const';

/**
 * @param props
 * @memberof module:wdh-feature-b2b
 * @example
 * <ErrorDetails />
 * @private
 */
var ErrorDetails = /*#__PURE__*/function (_React$Component) {
  function ErrorDetails(props) {
    var _this;
    _classCallCheck(this, ErrorDetails);
    _this = _callSuper(this, ErrorDetails, [props]);
    // do nothing
    _this.state = {
      showDetails: false
    };
    _this.translations = {
      showDetails: TranslationManager.getTranslation(TranslationKeys.SHOPINITIALIZATIONSPOT_UNHANDLEDEXCEPTION_SHOWDETAILS),
      hideDetails: TranslationManager.getTranslation(TranslationKeys.SHOPINITIALIZATIONSPOT_UNHANDLEDEXCEPTION_HIDEDETAILS),
      message: TranslationManager.getTranslation(TranslationKeys.SHOPINITIALIZATIONSPOT_UNHANDLEDEXCEPTION_MESSAGE),
      service: TranslationManager.getTranslation(TranslationKeys.SHOPINITIALIZATIONSPOT_UNHANDLEDEXCEPTION_SERVICE),
      stackTrace: TranslationManager.getTranslation(TranslationKeys.SHOPINITIALIZATIONSPOT_UNHANDLEDEXCEPTION_STACKTRACE)
    };
    return _this;
  }

  /**
   * Show details about the error
   * @private
   */
  _inherits(ErrorDetails, _React$Component);
  return _createClass(ErrorDetails, [{
    key: "showDetails",
    value: function showDetails() {
      this.setState({
        showDetails: true
      });
    }

    /**
     * Hide details about the error
     * @private
     */
  }, {
    key: "hideDetails",
    value: function hideDetails() {
      this.setState({
        showDetails: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var errorButtonStyle = {
        float: 'none',
        minWidth: '0'
      };
      if (this.state.showDetails) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
          className: "wdh-feature-b2b-button corporate-link-button",
          style: errorButtonStyle,
          onClick: function onClick(event) {
            return _this2.hideDetails(event);
          }
        }, this.translations.hideDetails), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, this.translations.message, ":"), " ", this.props.exception.message), this.props.exception.service && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, this.translations.service, ":"), " ", this.props.exception.service), this.props.exception.stackTrace && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, this.translations.stackTrace, ":"), this.props.exception.stackTrace.map(function (el) {
          return /*#__PURE__*/React.createElement("p", {
            key: el.toString().substring(el.toString().length - 20, 20)
          }, el);
        })), this.props.exception.innerException && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorDetails, {
          exception: this.props.exception.innerException
        }))));
      }
      return /*#__PURE__*/React.createElement("button", {
        className: "wdh-feature-b2b-button corporate-link-button",
        style: errorButtonStyle,
        onClick: function onClick(event) {
          return _this2.showDetails(event);
        }
      }, this.translations.showDetails);
    }
  }]);
}(React.Component);
ErrorDetails.propTypes = {
  exception: PropTypes.shape({
    correlationId: PropTypes.string,
    occuredAtUtc: PropTypes.string,
    service: PropTypes.string,
    message: PropTypes.string,
    stackTrace: PropTypes.string,
    innerException: PropTypes.object,
    data: PropTypes.object,
    hResult: PropTypes.number
  }).isRequired
};
export default ErrorDetails;